module.exports = __webpack_public_path__ + "img/Press_Release_Advisor_DAB_Group.bbd1cba6.jpeg";